import React from 'react';
import { MenuItem } from '@material-ui/core';
import { upperFirst } from 'lodash';

import { Select } from 'components/common/Select/Select';

const LanguageDropdown = props => {
  const { id, label, onChange, value, disabled, languageOptions } = props;

  // DOM Generator
  const createLanguageOptions = () => {
    const dropdownOptions = [];
    languageOptions?.forEach(language => {
      dropdownOptions.push(
        <MenuItem value={language} key={language}>
          {upperFirst(language)}
        </MenuItem>
      );
    });
    return dropdownOptions;
  };

  return (
    <Select id={id} variant="filled" label={label} value={value} onChange={onChange} defaultValue="" disabled={disabled}>
      {createLanguageOptions()}
    </Select>
  );
};

export default LanguageDropdown;
